import _ from 'lodash';
import {
    FETCH_JOKL_CREDITS,
    CLEAN_JOKL_CREDITS,
} from './types';
import { request, __ } from '../functions';

export const fetchJoklCredits = (screen, options = {}, id) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/jokl/credits/${id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_JOKL_CREDITS, payload: data });
    });
};

export const cleanJoklCredits = () => ({ type: CLEAN_JOKL_CREDITS });
